import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers';
import rootSaga from 'feedback-system/saga/root';

const sagaMiddleware = createSagaMiddleware();
const devMode = process.env.NODE_ENV !== 'production';

export default function configureAppStore() {
    const store = configureStore({
        reducer: rootReducer,
        middleware: [sagaMiddleware, ...getDefaultMiddleware({immutableCheck: false, serializableCheck: false})],
        devTools: devMode
    });

    if (devMode && module.hot) {
        module.hot.accept('../reducers', () => store.replaceReducer(rootReducer));
    }

    sagaMiddleware.run(rootSaga);

    return store;
}
